import {gql} from '@apollo/client';

import {QueryResultType, useBenchlingQuery} from 'graphql-client/BenchlingQuery';

import {
  GermlinesQuery,
  GermlinesQuery_allGermlines_GermlineNode as Germline,
} from './__generated/GermlinesQuery';

export type {Germline};

export const GERMLINES_QUERY = gql`
  query GermlinesQuery @skipAudit @engComponent(name: ANTIBODIES) {
    allGermlines {
      id
      name
      species
      type
      version
      variableNumberingScheme
      supportedChains
      constantDomains
    }
  }
`;

export type UseGermlinesQueryResult =
  | {
      status: QueryResultType.SUCCESS;
      germlines: Array<Germline>;
    }
  | {
      status: QueryResultType.ERROR | QueryResultType.PENDING;
      germlines: null;
    };

export function useGermlinesQuery(): UseGermlinesQueryResult {
  const result = useBenchlingQuery<GermlinesQuery>(GERMLINES_QUERY);

  if (result.type !== QueryResultType.SUCCESS) {
    return {status: result.type, germlines: null};
  }
  return {
    status: QueryResultType.SUCCESS,
    germlines: result.data.allGermlines,
  };
}
